import { StyledBox, StyledButton, StyledFlex } from '@tryhackme/thm-ui-components';
import styled from 'styled-components';

export const StyledCertificateCard = styled(StyledBox)`
  align-items: center;
  background-color: ${({ theme }) => theme.colors.background.lighter};
  display: grid;
  grid-template-columns: 1fr auto;
  padding: 1.6rem 2.4rem;
  margin-bottom: 2.4rem;
  width: 100%;

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    grid-template-columns: 1fr;
    gap: 2rem;
  }
`;

export const StyledButtonsWrapper = styled(StyledFlex)`
  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    justify-content: start;
  }
`;

export const StyledImageWrapper = styled.figure`
  border: 2px solid ${({ theme }) => theme.colors.border.light};
  border-radius: ${({ theme }) => theme.radius.small};
  height: 9.4rem;
  width: auto;
  overflow: hidden;

  img {
    width: inherit;
    height: inherit;
  }
`;

export const StyledContent = styled.div`
  h3 {
    margin-bottom: 0.8rem;
    font-size: ${({ theme }) => theme.fonts.sizes.medium};
  }
  p {
    color: ${({ theme }) => theme.colors.text.main};
    margin-bottom: 0.8rem;
  }
`;

export const StyledCertificateButton = styled(StyledButton)`
  &[data-type='download'] {
    padding: 0.85rem 0.9rem;

    svg {
      width: 1.6rem;
      height: 1.9rem;
    }
  }
  &[data-type='share'] {
    svg {
      height: auto;
      width: 1.5rem;
    }
  }
`;

export const StyledDate = styled.time`
  align-items: center;
  color: ${({ theme }) => theme.colors.radio.hover};
  display: flex;
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  gap: 0.8rem;

  svg {
    fill: ${({ theme }) => theme.colors.radio.hover};
    height: 1.4rem;
    width: auto;
  }
`;

export const StyledWrapperButton = styled.div`
  position: relative;
  &:hover {
    div[data-section='tooltip'] {
      visibility: visible;
      opacity: 1;
    }
  }
`;

export const StyledTooltip = styled.div`
  display: flex;
  position: absolute;
  top: -56px;
  left: 50%;
  transform: translateX(-50%);
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
`;
